<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-08-17 13:31:54
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Attendance\InternalUse\components\attendanceDialog.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-17 14:37:37
-->

<template>
  <v-navigation-drawer
    v-model="drawer"
    width="400"
    right
    @input="onChange"
    temporary
    :key="curKey"
    fixed
    :overlay-opacity="0"
  >
    <v-container
      fluid
      class="
        d-flex
        flex-column
        justify-space-around
        pa-0
        pb-0
        mrc-grey
        fill-height
      "
    >
      <v-toolbar
        flat
        dense
        class="pr-3"
        style="width: 100%"
        color="primary"
        height="48"
      >
        <v-toolbar-title class="text-subtitle-2">
          <v-list-item-title class="table-subttile white--text">
            {{ Data ? $getCommonLangValue(Data["preferred_name"]) : "" }}
          </v-list-item-title>
          <v-list-item-subtitle class="table-subttile white--text">
            {{ curData ? curData["roster_date"] : "" }}
          </v-list-item-subtitle>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-menu offset-x left min-width="200">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              class="mr-2"
              color="white"
              small
              v-show="!iSEdited"
            >
              <span class="material-icons-round">edit</span>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="toChangeRecord">
              <v-list-item-title>{{
                $t(
                  "label_essweb_RosterFormRecord_form_slide_modifyAttenndanceRecordLabel"
                )
              }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" @click.stop="closeDialog" color="white" small>
              <span class="material-icons-round">close</span>
            </v-btn>
          </template>
          <span>{{
            $t("label_essweb_RosterFormRecord_form_slide_closeBtnTip")
          }}</span>
        </v-tooltip>
      </v-toolbar>
      <v-container
        fluid
        class="pa-3 mrc-grey scroll_content_y"
        :style="{
          height: iSEdited ? 'calc(100% - 96px)' : 'calc(100% - 48px)',
        }"
      >
        <noContent v-if="!Data" />
        <v-container fluid class="justify-start pa-0 transparent" v-if="Data">
          <!-- 2020-11-18 bug1021 -->
          <!-- <v-sheet class="transparent pa-0" width="100%">
            <v-list-item dense two-line class="pa-0 ma-0 transparent">
              <v-list-item-avatar size="36" class='mr-1 my-0 pa-0'>
                <v-img :src="Data.staff_avatar"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $getCommonLangValue(Data.preferred_name) }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ $getCommonLangValue(Data.job_post_name) }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-sheet> -->
          <!-- tag -->
          <v-sheet
            class="
              d-flex
              flex-row
              justify-space-around
              transparent
              align-center
            "
            width="100%"
          >
            <v-sheet min-width="80%" class="transparent">
              <v-chip
                small
                class="ma-1 white--text"
                :color="$getTagColors($card_line_colors, 'is_late_1')"
                v-if="Number(Data['is_late'])"
                >{{ $t("label_essweb_system_tag_label_lateLabel") }}</v-chip
              >
              <v-chip
                small
                class="ma-1 white--text"
                :color="$getTagColors($card_line_colors, 'is_ot_1')"
                v-if="Number(Data['is_ot'])"
                >{{ $t("label_essweb_system_tag_label_otLabel") }}</v-chip
              >
              <v-chip
                small
                v-if="Number(Data['is_missing_punch'])"
                :color="$getTagColors($card_line_colors, 'is_missing_punch_1')"
                class="ma-1 white--text"
                >{{
                  $t("label_essweb_system_tag_label_isMissingPunchLabel")
                }}</v-chip
              >
              <v-chip
                small
                v-if="Number(Data['is_adhoc'])"
                :color="$getTagColors($card_line_colors, 'is_adhoc_1')"
                class="ma-1 text--primary"
                >{{ $t("label_essweb_system_tag_label_isAdhocLabel") }}</v-chip
              >
              <!-- <v-chip
                small
                class="white--text"
                color="#12B282"
                v-if="Number(Data['is_on_leave'])"
                >{{ $t("label_essweb_system_tag_label_leaveLabel") }}</v-chip> -->
              <template v-if="Number(Data['is_on_leave'])">
                <v-chip
                  small
                  outlined
                  :color="leave.color_code"
                  v-for="(leave, index) in Data.leave_info"
                  :key="`leave--${index}`"
                  class="ma-1"
                  >{{ $getCommonLangValue(leave["leave_type_name"]) }}</v-chip
                >
              </template>
              <template v-if="Number(Data['holiday_info'])">
                <v-chip
                  small
                  :color="$getTagColors($card_line_colors, 'is_holiday_1')"
                  v-for="(holiday, index) in Data['holiday_info']"
                  :key="`holiday--${index}`"
                  class="ma-1 text--primary"
                  >{{ $getCommonLangValue(holiday["holiday_name"]) }}</v-chip
                >
              </template>
              <v-chip
                small
                class="ma-1 white--text"
                :color="$getTagColors($card_line_colors, 'is_on_duty_1')"
                v-if="Number(Data['is_onDuty'])"
                >{{ $t("label_essweb_system_tag_label_isOnDutyLabel") }}</v-chip
              >
              <v-chip
                small
                class="ma-1 white--text"
                :color="$getTagColors($card_line_colors, 'is_early_leave_1')"
                v-if="Number(Data['is_early_leave'])"
                >{{
                  $t("label_essweb_system_tag_label_earlyLeaveLabel")
                }}</v-chip
              >
              <v-chip
                small
                class="ma-1 white--text"
                :color="$getTagColors($card_line_colors, 'is_absense_1')"
                v-if="Number(Data['is_absense'])"
                >{{ $t("label_essweb_system_tag_label_absenseLabel") }}</v-chip
              >
              <v-chip
                small
                class="ma-1 text--primary"
                :color="$getTagColors($card_line_colors, 'is_work_from_home_1')"
                v-if="Number(Data['is_work_from_home'])"
                >{{
                  $t("label_essweb_punchRecord_list_tag_workFromHomeLabbel")
                }}</v-chip
              >
              <v-chip
                small
                class="ma-1 text--primary"
                :color="$getTagColors($card_line_colors, 'is_out_of_office_1')"
                v-if="Number(Data['is_out_of_office'])"
                >{{
                  $t("label_essweb_system_tag_label_isOutOfOfficeLabel")
                }}</v-chip
              >
            </v-sheet>
            <v-spacer></v-spacer>
            <v-btn
              icon
              :color="$getTagColors($card_line_colors, 'is_locked_1')"
              v-if="Number(Data['is_locked'])"
            >
              <span class="material-icons-round">lock</span>
            </v-btn>
          </v-sheet>
          <!-- official/actual -->
          <v-sheet
            width="100%"
            elevation="0"
            class="pa-2 rounded-xl panel_right mt-4 mb-4"
          >
            <Taber
              :curTab="curTab"
              @change="(tab) => (curTab = tab)"
              :items="taber"
              special
              backgroundColor="white"
              :centered="false"
              :grow="false"
            >
              <template v-slot:content-1>
                <v-form
                  class="max-width"
                  :class="iSEdited ? 'px-0' : 'px-3'"
                  ref="recordform"
                  lazy-validation
                >
                  <v-row class="max-width mx-0 py-3" align="center">
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 5
                          : 7
                      "
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalWorkingLabel"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 7
                          : 5
                      "
                      class="text-center"
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <div>
                        <span
                          v-if="
                            !(
                              iSEdited &&
                              Number(
                                Data['is_allow_modify_attendance_total']
                              ) == 1
                            )
                          "
                        >
                          {{
                            $timeMachine(
                              Data["official_working_minutes"] || 0,
                              false
                            )
                          }}</span
                        >

                        <TimePickerSheet
                          v-else
                          isRequire
                          format
                          :height="25"
                          hideDetail
                          :showLabel="false"
                          :value="Data.modified_working_minutes"
                          :defaultTime="Data.modified_working_minutes"
                          placeholder="00:00"
                          :label="
                            $t(
                              'label_essweb_attendanceModifiApp_form_totalWorkingLabel'
                            )
                          "
                          @change="
                            (time) => {
                              Data.modified_working_minutes = time;
                            }
                          "
                        />
                      </div>
                    </v-col>
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 5
                          : 7
                      "
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalBreakMinutesLabel"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 7
                          : 5
                      "
                      class="text-center"
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <span
                        v-if="
                          !(
                            iSEdited &&
                            Number(Data['is_allow_modify_attendance_total']) ==
                              1
                          )
                        "
                      >
                        {{
                          $timeMachine(
                            Data["official_break_minutes"] || 0,
                            false
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-else
                        isRequire
                        format
                        :height="25"
                        hideDetail
                        :showLabel="false"
                        :value="Data.modified_break_minutes"
                        :defaultTime="Data.modified_break_minutes"
                        placeholder="00:00"
                        :label="
                          $t(
                            'label_essweb_attendanceModifiApp_form_totalBreakMinutesLabel'
                          )
                        "
                        @change="
                          (time) => {
                            Data.modified_break_minutes = time;
                          }
                        "
                      />
                    </v-col>
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 5
                          : 7
                      "
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalMealMinutes"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 7
                          : 5
                      "
                      class="text-center"
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <span
                        v-if="
                          !(
                            iSEdited &&
                            Number(Data['is_allow_modify_attendance_total']) ==
                              1
                          )
                        "
                      >
                        {{
                          $timeMachine(
                            Data["official_meal_minutes"] || 0,
                            false
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-else
                        isRequire
                        format
                        :height="25"
                        hideDetail
                        :showLabel="false"
                        :value="Data.modified_meal_mintues"
                        :defaultTime="Data.modified_meal_mintues"
                        placeholder="00:00"
                        :label="
                          $t(
                            'label_essweb_attendanceModifiApp_form_totalMealMinutes'
                          )
                        "
                        @change="
                          (time) => {
                            Data.modified_meal_mintues = time;
                          }
                        "
                      />
                    </v-col>
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 5
                          : 7
                      "
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalOTLabel"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 7
                          : 5
                      "
                      class="text-center"
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <span
                        v-if="
                          !(
                            iSEdited &&
                            Number(Data['is_allow_modify_attendance_total']) ==
                              1
                          )
                        "
                      >
                        {{
                          $timeMachine(
                            Data["official_total_ot_minutes"] || 0,
                            false
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-else
                        isRequire
                        format
                        :height="25"
                        hideDetail
                        :showLabel="false"
                        :value="Data.modified_ot_minutes"
                        :defaultTime="Data.modified_ot_minutes"
                        placeholder="00:00"
                        :label="
                          $t(
                            'label_essweb_attendanceModifiApp_form_totalOTLabel'
                          )
                        "
                        @change="
                          (time) => {
                            Data.modified_ot_minutes = time;
                          }
                        "
                      />
                    </v-col>
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 5
                          : 7
                      "
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalLateLabel"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 7
                          : 5
                      "
                      class="text-center"
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <span
                        v-if="
                          !(
                            iSEdited &&
                            Number(Data['is_allow_modify_attendance_total']) ==
                              1
                          )
                        "
                      >
                        {{
                          $timeMachine(
                            Data["official_total_late_minutes"] || 0,
                            false
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-else
                        isRequire
                        format
                        :height="25"
                        hideDetail
                        :showLabel="false"
                        :value="Data.modified_late_minutes"
                        :defaultTime="Data.modified_late_minutes"
                        placeholder="00:00"
                        :label="
                          $t(
                            'label_essweb_attendanceModifiApp_form_totalLateLabel'
                          )
                        "
                        @change="
                          (time) => {
                            Data.modified_late_minutes = time;
                          }
                        "
                      />
                    </v-col>
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 5
                          : 7
                      "
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalEarlyLeaveLabel"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 7
                          : 5
                      "
                      class="text-center"
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <span
                        v-if="
                          !(
                            iSEdited &&
                            Number(Data['is_allow_modify_attendance_total']) ==
                              1
                          )
                        "
                      >
                        {{
                          $timeMachine(
                            Data["official_total_early_leave_minutes"] || 0,
                            false
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-else
                        isRequire
                        format
                        :height="25"
                        hideDetail
                        :showLabel="false"
                        :value="Data.modified_early_leave_minutes"
                        :defaultTime="Data.modified_early_leave_minutes"
                        placeholder="00:00"
                        :label="
                          $t(
                            'label_essweb_attendanceModifiApp_form_totalEarlyLeaveLabel'
                          )
                        "
                        @change="
                          (time) => {
                            Data.modified_early_leave_minutes = time;
                          }
                        "
                      />
                    </v-col>
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 5
                          : 7
                      "
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalLeaveLabel"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 7
                          : 5
                      "
                      class="text-center"
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <span
                        v-if="
                          !(
                            iSEdited &&
                            Number(Data['is_allow_modify_attendance_total']) ==
                              1
                          )
                        "
                      >
                        {{
                          $timeMachine(
                            Data["official_total_leave_minutes"] || 0,
                            false
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-else
                        isRequire
                        format
                        :height="25"
                        hideDetail
                        :showLabel="false"
                        :value="Data.modified_leave_minutes"
                        :defaultTime="Data.modified_leave_minutes"
                        placeholder="00:00"
                        :label="
                          $t(
                            'label_essweb_attendanceModifiApp_form_totalLeaveLabel'
                          )
                        "
                        @change="
                          (time) => {
                            Data.modified_leave_minutes = time;
                          }
                        "
                      />
                    </v-col>
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 5
                          : 7
                      "
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalAbsenseLabel"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 7
                          : 5
                      "
                      class="text-center"
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <span
                        v-if="
                          !(
                            iSEdited &&
                            Number(Data['is_allow_modify_attendance_total']) ==
                              1
                          )
                        "
                      >
                        {{
                          $timeMachine(
                            Data["official_absense_minutes"] || 0,
                            false
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-else
                        isRequire
                        format
                        :height="25"
                        hideDetail
                        :showLabel="false"
                        :value="Data.modified_absense_minutes"
                        :defaultTime="Data.modified_absense_minutes"
                        placeholder="00:00"
                        :label="
                          $t(
                            'label_essweb_attendanceModifiApp_form_totalAbsenseLabel'
                          )
                        "
                        @change="
                          (time) => {
                            Data.modified_absense_minutes = time;
                          }
                        "
                      />
                    </v-col>
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 5
                          : 7
                      "
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalBeforeWorkLabel"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 7
                          : 5
                      "
                      class="text-center"
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <span
                        v-if="
                          !(
                            iSEdited &&
                            Number(Data['is_allow_modify_attendance_total']) ==
                              1
                          )
                        "
                      >
                        {{
                          $timeMachine(
                            Data["official_before_work_minutes"] || 0,
                            false
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-else
                        isRequire
                        format
                        :height="25"
                        hideDetail
                        :showLabel="false"
                        :value="Data.modified_before_work_minutes"
                        :defaultTime="Data.modified_before_work_minutes"
                        placeholder="00:00"
                        :label="
                          $t(
                            'label_essweb_attendanceModifiApp_form_totalBeforeWorkLabel'
                          )
                        "
                        @change="
                          (time) => {
                            Data.modified_before_work_minutes = time;
                          }
                        "
                      />
                    </v-col>
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 5
                          : 7
                      "
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalAfterWorkLabel"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="
                        iSEdited &&
                        Number(Data['is_allow_modify_attendance_total']) == 1
                          ? 7
                          : 5
                      "
                      class="text-center"
                      :class="
                        !(
                          iSEdited &&
                          Number(Data['is_allow_modify_attendance_total']) == 1
                        )
                          ? 'pa-0'
                          : 'pt-1 '
                      "
                    >
                      <span
                        v-if="
                          !(
                            iSEdited &&
                            Number(Data['is_allow_modify_attendance_total']) ==
                              1
                          )
                        "
                      >
                        {{
                          $timeMachine(
                            Data["official_after_work_minutes"] || 0,
                            false
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-else
                        isRequire
                        format
                        :height="25"
                        hideDetail
                        :showLabel="false"
                        :value="Data.modified_after_work_minutes"
                        :defaultTime="Data.modified_after_work_minutes"
                        placeholder="00:00"
                        :label="
                          $t(
                            'label_essweb_attendanceModifiApp_form_totalAfterWorkLabel'
                          )
                        "
                        @change="
                          (time) => {
                            Data.modified_after_work_minutes = time;
                          }
                        "
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </template>
              <template v-slot:content-2>
                <div class="px-3">
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalWorkingLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(Data["actual_working_minutes"] || 0, false)
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalBreakMinutesLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(Data["actual_break_minutes"] || 0, false)
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalMealMinutes"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(Data["actual_meal_minutes"] || 0, false)
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t("label_essweb_attendanceModifiApp_form_totalOTLabel")
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{ $timeMachine(Data["actual_ot_minutes"] || 0, false) }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalLateLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(Data["actual_late_minutes"] || 0, false)
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalEarlyLeaveLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["actual_early_leave_minutes"] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalLeaveLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(Data["actual_leave_minutes"] || 0, false)
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalAbsenseLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(Data["actual_absense_minutes"] || 0, false)
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalBeforeWorkLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["actual_before_work_minutes"] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalAfterWorkLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["actual_after_work_minutes"] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                </div>
              </template>
            </Taber>
          </v-sheet>
          <v-sheet
            height="1"
            width="100%"
            color="grey lighten-2"
            class="mt-8 mb-8"
          ></v-sheet>
          <!-- shift -->
          <v-sheet
            class="rounded-xl pa-3 mt-4"
            style="overflow: hidden"
            width="100%"
            elevation="0"
          >
            <v-sheet class="d-flex flex-row justify-space-between">
              <div style="width: 24px" class="text-center">
                <svg-icon
                  size="24"
                  :fill="Data['official_shift_color_code']"
                  iconClass="LabeledColour"
                />
              </div>
              <div style="max-width: calc(100% - 120px)" class="pl-1">
                {{ $getCommonLangValue(Data["official_shift_name"]) }}
              </div>
              <v-spacer></v-spacer>
              <div class="text--secondary" style="max-width: 100px">
                {{
                  $getDateTime(Data["official_start_utc_time"], "HH:mm") +
                  " - " +
                  $getDateTime(Data["official_end_utc_time"], "HH:mm")
                }}
              </div>
            </v-sheet>
            <!-- site bug687 -->
            <v-sheet
              class="d-flex flex-row justify-start"
              v-if="Data['site_name']"
            >
              <div style="width: 24px" class="text-center">
                <svg-icon size="16" fill="grey" iconClass="site" />
              </div>
              <div class="pl-1 text--secondary">
                {{ $getCommonLangValue(Data["site_name"]) }}
              </div>
            </v-sheet>
            <!-- cost_center_name bug688 -->
            <v-sheet
              class="d-flex flex-row justify-start"
              v-if="Data['cost_center_name']"
            >
              <div style="width: 24px" class="text-center">
                <svg-icon size="16" fill="grey" iconClass="cost_center" />
              </div>
              <div class="pl-1 text--secondary">
                {{ $getCommonLangValue(Data["cost_center_name"]) }}
              </div>
            </v-sheet>
            <!-- 2020-11-18 bug1021 -->
            <v-sheet
              class="d-flex flex-row justify-start"
              v-if="Data['leave_type_remark_name']"
            >
              <div style="width: 24px" class="text-center">
                <span class="material-icons-round text--secondary">today</span>
              </div>
              <div class="pl-1 text--secondary">
                {{ $getCommonLangValue(Data["leave_type_remark_name"]) }}
              </div>
            </v-sheet>
            <!-- 2020-11-18 bug1021 -->
            <v-sheet
              class="d-flex flex-row justify-start"
              v-if="Data['remarks']"
            >
              <div style="width: 24px" class="text-center flex-shrink-1">
                <svg-icon
                  size="16"
                  fill="rgba(0, 0, 0, 0.54)"
                  iconClass="mini_doc"
                />
              </div>
              <div
                class="pl-1 text--secondary text-ellipsis-2"
                style="width: calc(100% - 24px)"
                :title="Data['remarks']"
              >
                {{ Data["remarks"] }}
              </div>
            </v-sheet>
          </v-sheet>
          <!-- event -->
          <v-sheet
            elevation="0"
            width="100%"
            class="rounded-xl d-flex mt-4 flex-column"
          >
            <v-sheet
              class="ma-4"
              v-for="(item, index) in Data['ess_att_attendance_detail']"
              :key="`detail${index}`"
            >
              <v-sheet class="text-subtitle-2" style="width: 100%">{{
                $getCommonLangValue(item.event_type_name)
              }}</v-sheet>
              <v-sheet class="d-flex flex-row justify-start mt-2">
                <v-sheet
                  width="8"
                  height="auto"
                  color="primary lighten-4 rounded-xl mr-2"
                ></v-sheet>
                <v-sheet>
                  <div class="text-subtitle-2 text--secondary">
                    {{
                      $t(
                        "label_essweb_attendanceModifiApp_form_scheduleShiftTimeLabel"
                      )
                    }}
                  </div>
                  <div class="text-subtitle-2">
                    {{
                      $getDateTime(item.schedule_start_utc_time, "HH:mm") +
                      " - " +
                      $getDateTime(item.schedule_end_utc_time, "HH:mm")
                    }}
                  </div>
                </v-sheet>
              </v-sheet>
              <v-sheet class="d-flex flex-row justify-start mt-2">
                <v-sheet
                  width="8"
                  height="auto"
                  color="primary lighten-2 rounded-xl mr-2"
                ></v-sheet>

                <v-sheet>
                  <div class="text-subtitle-2 text--secondary">
                    {{
                      $t(
                        "label_essweb_attendanceModifiApp_form_officialShiftTimeLabel"
                      )
                    }}
                  </div>
                  <div class="text-subtitle-2">
                    {{
                      $getDateTime(item.official_start_utc_time, "HH:mm") +
                      " - " +
                      $getDateTime(item.official_end_utc_time, "HH:mm")
                    }}
                  </div>
                </v-sheet>
              </v-sheet>
              <v-sheet class="d-flex flex-row justify-start mt-2">
                <v-sheet
                  width="8"
                  height="auto"
                  color="primary base rounded-xl mr-2"
                ></v-sheet>

                <v-sheet width="100%">
                  <div class="text-subtitle-2 text--secondary">
                    {{
                      $t(
                        "label_essweb_attendanceModifiApp_form_actualPunchTime"
                      )
                    }}
                  </div>
                  <!-- <div class="text-subtitle-2">
                        {{
                          $getDateTime(
                            item.actual_punch_in_utc_datetime,
                            "HH:mm"
                          ) +
                            " - " +
                            $getDateTime(
                              item.actual_punch_out_utc_datetime,
                              "HH:mm"
                            )
                        }}
                      </div> -->
                  <div
                    class="
                      d-flex
                      flex-row
                      justify-space-between
                      flex-grow-1
                      mt-2
                    "
                    style="width: 100%"
                  >
                    <v-sheet
                      color="grey lighten-3 text-subtitle-2 text-center rounded"
                      width="50%"
                    >
                      {{
                        $getDateTime(item.actual_punch_in_utc_datetime, "HH:mm")
                      }}
                    </v-sheet>
                    <div style="width: 20px" class="text-center">-</div>
                    <v-sheet
                      color="grey lighten-3 text-subtitle-2 text-center rounded"
                      width="50%"
                    >
                      {{
                        $getDateTime(
                          item.actual_punch_out_utc_datetime,
                          "HH:mm"
                        )
                      }}
                    </v-sheet>
                  </div>
                </v-sheet>
              </v-sheet>
              <!--  -->
              <v-sheet
                class="d-flex flex-row justify-start mt-2"
                v-if="iSEdited"
              >
                <v-sheet
                  width="8"
                  height="auto"
                  color="primary rounded-xl mr-2"
                ></v-sheet>
                <v-sheet width="100%">
                  <div class="text-subtitle-2 text--secondary">
                    {{
                      $t(
                        "label_essweb_attendanceModifiApp_form_modifilyOfficialPunchTime"
                      )
                    }}
                  </div>
                  <div
                    class="
                      d-flex
                      flex-row
                      justify-space-between
                      flex-grow-1
                      mt-2
                    "
                    style="width: 100%"
                  >
                    <v-sheet
                      color="grey lighten-3 text-subtitle-2 text-center rounded"
                      width="50%"
                    >
                      <span v-if="!Number(item.is_punch_in_required)">
                        {{
                          $getDateTime(
                            item.modified_punch_in_utc_datetime_save,
                            "HH:mm"
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-if="iSEdited && Number(item.is_punch_in_required)"
                        isRequire
                        hideDetail
                        :show48="23"
                        showDay
                        @modify="
                          item.is_change_modified_punch_in_utc_datetime = true
                        "
                        :showLabel="false"
                        :max="item.modified_punch_out_utc_datetime"
                        :value="item.modified_punch_in_utc_datetime"
                        :defaultTime="item.modified_punch_in_utc_datetime"
                        placeholder="--:--"
                        @change="
                          (time) => {
                            item.modified_punch_in_utc_datetime = time;
                          }
                        "
                      />
                    </v-sheet>
                    <div style="width: 20px" class="text-center">-</div>
                    <v-sheet
                      color="grey lighten-3 text-subtitle-2 text-center rounded"
                      width="50%"
                    >
                      <span v-if="!Number(item.is_punch_out_required)">
                        {{
                          $getDateTime(
                            item.modified_punch_out_utc_datetime_save,
                            "HH:mm"
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-if="iSEdited && Number(item.is_punch_out_required)"
                        isEnd
                        :show48="23"
                        isRequire
                        showDay
                        @modify="
                          item.is_change_modified_punch_out_utc_datetime = true
                        "
                        hideDetail
                        :showLabel="false"
                        :min="item.modified_punch_in_utc_datetime"
                        :value="item.modified_punch_out_utc_datetime"
                        :defaultTime="item.modified_punch_out_utc_datetime"
                        placeholder="__:__"
                        @change="
                          (time) => {
                            item.modified_punch_out_utc_datetime = time;
                          }
                        "
                    /></v-sheet>
                  </div>
                </v-sheet>
              </v-sheet>
              <!--  -->
              <v-sheet class="d-flex flex-row justify-start mt-2">
                <v-sheet
                  width="8"
                  height="auto"
                  color="primary rounded-xl mr-2"
                ></v-sheet>

                <v-sheet width="100%">
                  <div class="text-subtitle-2 text--secondary">
                    {{
                      $t(
                        "label_essweb_attendanceModifiApp_form_officialPunchTime"
                      )
                    }}
                  </div>
                  <div
                    class="
                      d-flex
                      flex-row
                      justify-space-between
                      flex-grow-1
                      mt-2
                    "
                    style="width: 100%"
                  >
                    <v-sheet
                      color="grey lighten-3 text-subtitle-2 text-center rounded"
                      width="50%"
                      :title="
                        $getDateTime(
                          item.official_punch_in_utc_datetime_save,
                          'YYYY/MM/DD HH:mm'
                        )
                      "
                    >
                      {{
                        Math.floor(
                          Math.abs(
                            item["official_punch_in_utc_datetime_save_minutes"]
                          ) / 1440
                        ) == 0
                          ? ""
                          : item["official_punch_in_utc_datetime_save_minutes"]
                          ? item[
                              "official_punch_in_utc_datetime_save_minutes"
                            ] > 0
                            ? "(+" +
                              Math.floor(
                                Math.abs(
                                  item[
                                    "official_punch_in_utc_datetime_save_minutes"
                                  ]
                                ) / 1440
                              ) +
                              ")"
                            : "(-" +
                              Math.floor(
                                Math.abs(
                                  item[
                                    "official_punch_in_utc_datetime_save_minutes"
                                  ]
                                ) / 1440
                              ) +
                              ")"
                          : ""
                      }}
                      <span>
                        {{
                          $getDateTime(
                            item.official_punch_in_utc_datetime_save,
                            "HH:mm"
                          )
                        }}
                      </span>
                    </v-sheet>
                    <div style="width: 20px" class="text-center">-</div>
                    <v-sheet
                      color="grey lighten-3 text-subtitle-2 text-center rounded"
                      width="50%"
                      :title="
                        $getDateTime(
                          item.official_punch_out_utc_datetime_save,
                          'YYYY/MM/DD HH:mm'
                        )
                      "
                    >
                      {{
                        Math.floor(
                          Math.abs(
                            item["official_punch_out_utc_datetime_save_minutes"]
                          ) / 1440
                        ) == 0
                          ? ""
                          : item["official_punch_out_utc_datetime_save_minutes"]
                          ? item[
                              "official_punch_out_utc_datetime_save_minutes"
                            ] > 0
                            ? "(+" +
                              Math.floor(
                                Math.abs(
                                  item[
                                    "official_punch_out_utc_datetime_save_minutes"
                                  ]
                                ) / 1440
                              ) +
                              ")"
                            : "(-" +
                              Math.floor(
                                Math.abs(
                                  item[
                                    "official_punch_out_utc_datetime_save_minutes"
                                  ]
                                ) / 1440
                              ) +
                              ")"
                          : ""
                      }}
                      <span>
                        {{
                          $getDateTime(
                            item.official_punch_out_utc_datetime_save,
                            "HH:mm"
                          )
                        }}
                      </span>
                    </v-sheet>
                  </div>
                  <!-- <div
                    class="d-flex flex-row justify-space-between flex-grow-1 mt-2"
                    style="width: 100%"
                  >
                    <v-sheet
                      color="grey lighten-3 text-subtitle-2 text-center rounded"
                      width="50%"
                    >
                      <span v-if="!iSEdited || !item.actual_punch_in_uuid">
                        {{
                          $getDateTime(
                            item.official_punch_in_utc_datetime_save,
                            "HH:mm"
                          )
                        }}
                      </span>

                      <TimePickerSheet
                        v-if="iSEdited && Number(item.is_punch_in_required)"
                        isRequire
                        hideDetail
                        :disable="!iSEdited"
                        :showLabel="false"
                        :max="item.official_punch_out_utc_datetime"
                        :value="item.official_punch_in_utc_datetime"
                        :defaultTime="item.official_punch_in_utc_datetime"
                        placeholder="--:--"
                        @change="
                          (time) => {
                            item.official_punch_in_utc_datetime = time;
                          }
                        "
                      />
                    </v-sheet>
                    <div style="width: 20px" class="text-center">-</div>
                    <v-sheet
                      color="grey lighten-3 text-subtitle-2 text-center rounded"
                      width="50%"
                    >
                      <span v-if="!iSEdited || !item.actual_punch_out_uuid">
                        {{
                          $getDateTime(
                            item.official_punch_out_utc_datetime_save,
                            "HH:mm"
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-if="iSEdited && Number(item.is_punch_out_required)"
                        isEnd
                        isRequire
                        showDay
                        :disable="!iSEdited"
                        hideDetail
                        :showLabel="false"
                        :min="item.official_punch_in_utc_datetime"
                        :value="item.official_punch_out_utc_datetime"
                        :defaultTime="item.official_punch_out_utc_datetime"
                        placeholder="__:__"
                        @change="
                          (time) => {
                            item.official_punch_out_utc_datetime = time;
                          }
                        "
                      />
                    </v-sheet>
                  </div> -->
                  <!-- 2021-03-19 不显示 brain lsj -->
                  <div class="mt-2" v-if="false">
                    <v-chip small>
                      {{
                        $t("label_essweb_attendanceModifiApp_form_totalLabel")
                      }}({{
                        $timeMachine(item.official_working_minutes, true)
                      }})
                    </v-chip>
                    <v-chip
                      small
                      color="red"
                      v-if="Number(item.late_minutes) > 0"
                    >
                      {{
                        $t("label_essweb_attendanceModifiApp_form_lateLabel")
                      }}({{ $timeMachine(item.late_minutes, true) }})
                    </v-chip>
                    <v-chip
                      small
                      color="red"
                      v-if="Number(item.early_leave_minutes) > 0"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_earlyLeaveLabel"
                        )
                      }}({{ $timeMachine(item.early_leave_minutes, true) }})
                    </v-chip>
                    <v-chip
                      small
                      color="primary"
                      v-if="
                        Number(item.ot_minutes_before) +
                        Number(item.ot_minutes_after)
                      "
                    >
                      {{
                        $t("label_essweb_attendanceModifiApp_form_otLabel")
                      }}({{
                        $timeMachine(
                          Number(item.ot_minutes_before) +
                            Number(item.ot_minutes_after),
                          true
                        )
                      }})
                    </v-chip>
                  </div>
                </v-sheet>
              </v-sheet>
            </v-sheet>
          </v-sheet>
        </v-container>
      </v-container>
      <v-spacer></v-spacer>
      <v-sheet
        height="48"
        width="100%"
        v-if="iSEdited"
        class="align-center text-center d-flex justify-center"
      >
        <v-btn
          color="gery"
          rounded
          text
          height="32"
          class="pl-7 pr-7 text-capitalize mr-2"
          @click="closeDialog"
          >{{
            $t("label_essweb_RosterFormRecord_form_slide_form_cancelLabel")
          }}</v-btn
        >
        <v-btn
          color="primary"
          rounded
          height="32"
          class="pl-7 pr-7 text-capitalize"
          :disabled="!curSelect"
          @click="toSubmit"
          >{{
            $t("label_essweb_RosterFormRecord_form_slide_form_submitBtnLabel")
          }}</v-btn
        >
      </v-sheet>
    </v-container>
    <!-- !!!!!!!!!!!!!!!!!!!!!! -->
    <template> </template>
    <!-- !!!!!!!!!!!!!!!!!! -->
    <!-- select Sender -->
    <!-- 2020-11-24 改为不走审批 -->
    <!-- 2021-04-06 判断是否走审批 -->
    <!-- 2021-08-26 内部考勤不走审批 -->
    <!-- <selectSender
      :show="showSender"
      :staff_uuid="curStaff"
      @onSave="toSave"
      @close="showSender = false"
    /> -->
  </v-navigation-drawer>
</template>
<script>
import { mapGetters } from "vuex";
import selectSender from "@/Page/Ess/Roster/RosterFormRecord/components/selectSender";
import dayjs from "dayjs";
export default {
  name: "RosterShiftDialog",
  components: { selectSender },
  props: {
    show: { default: false, type: Boolean },
    curData: { deffult: null, type: Object },
    curUuid: { deffult: "", type: String },
  },
  computed: {
    ...mapGetters(["companyLang", "AppInfo"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
    curDate() {
      return this.curData["roster_date"];
    },
    LeaveType() {
      return this.$getSelectTrans(this.LeaveTypeData, "leave_type_name");
    },
    curShift() {
      const that = this;
      var curshift = null;
      if (this.curData !== null && this.curDate !== "") {
        let curTemp = [];
        if (this.curData.rosters) {
          curTemp = this.curData.rosters.filter(
            (ele) =>
              dayjs(ele.roster_utc_datetime).format("YYYY-MM-DD") ===
              this.curDate
          );
        } else {
          this.curData.rosters = [];
        }

        this.shiftLen = curTemp.length;
        this.curAllShift = curTemp;
        if (curTemp.length > 0) {
          curshift = curTemp[0];
          this.curSelect = curshift["shift_uuid"];
        }
      }
      return curshift;
    },
    shiftList() {
      // return this.$getSelectTrans(this.shiftListData, "shift_name");
      return this.shiftListData;
    },
    drawer: {
      get() {
        return this.show;
      },
      set(val) {
        return val;
      },
    },
  },
  watch: {
    curUuid(val) {
      this.iSEdited = false;
      if (val) {
        this.getDetail(val);
      }
    },
    show(val) {
      if (!val) {
        if (this.$refs["form"]) this.$refs["form"].reset();
        this.curSelect = null;
        this.shiftListData = [];
        this.curKey = Math.random() * 1000000000;
      }
    },
    curData(val) {
      if (val) {
        const that = this;
        // var curshift = null;
        // if (this.curData !== null && this.curDate !== "") {
        //   let curTemp = [];
        //   if (this.curData.rosters) {
        //     curTemp = this.curData.rosters.filter(
        //       (ele) =>
        //         dayjs(ele.roster_utc_datetime).format("YYYY-MM-DD") ===
        //         this.curDate
        //     );
        //   } else {
        //     this.curData.rosters = [];
        //   }
        //   this.shiftLen = curTemp.length;
        //   this.curAllShift = curTemp;
        //   if (curTemp.length > 0) {
        //     curshift = curTemp[0];
        this.curSelect = val["official_shift_uuid"];
        // }
        // }
      }
    },
  },
  mounted() {
    this.getLeaveType();
    // this.shiftData.shift_name = this.$getCommonLangKey(this.companyLang);
    // this.shiftData.shift_description = this.$getCommonLangKey(this.companyLang);
    // this.shiftData.shift_abbr = this.$getCommonLangKey(this.companyLang);
  },
  data() {
    return {
      shiftListData: [],
      showSender: false,
      curSelect: null,
      Data: null,
      curKey: "123",
      LeaveTypeData: [],
      iSEdited: false,
      is_skip_approval: 0,
      curStaff: null,
      curTab: "tab-1",
      taber: [
        "label_essweb_attendanceModifiApp_form_tab_officialLabel",
        "label_essweb_attendanceModifiApp_form_tab_actualLabel",
      ],
      isRefresh: 0,
      shiftData: {
        uuid: "",
        shift_abbr: "",
        start_utc_time: 0,
        end_utc_time: 0,
        prefix_shift_abbr: "",
        suffix_shift_abbr: "",
        event_list: [],
      },
      curStaff: null,
    };
  },
  methods: {
    getDetail: function (uuid) {
      const that = this;
      that.Data = null;
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_master",
        url: "/attendance-master/get-details/",
        global: false,
        data: { uuid: uuid },
      }).then((res) => {
        that.is_skip_approval = 1; ////跳过选择审批人,lsj//内部记录不走审批
        if (res.data["ess_att_attendance_detail"]) {
          res.data["ess_att_attendance_detail"].map((item) => {
            // 记录修改
            item["is_change_official_punch_in_utc_datetime"] = false;
            item["is_change_modified_punch_in_utc_datetime"] = false;
            item["is_change_modified_punch_out_utc_datetime"] = false;
            item["is_change_official_punch_out_utc_datetime"] = false;
            //
            item["official_punch_in_utc_datetime_save"] =
              item["official_punch_in_utc_datetime"];
            item["official_punch_out_utc_datetime_save"] =
              item["official_punch_out_utc_datetime"];
            item["modified_punch_in_utc_datetime_save"] =
              item["modified_punch_in_utc_datetime"];
            item["modified_punch_out_utc_datetime_save"] =
              item["modified_punch_out_utc_datetime"];
            if (item["official_punch_in_utc_datetime"]) {
              let day =
                new Date(
                  dayjs(item["official_punch_in_utc_datetime"]).format(
                    "YYYY-MM-DD"
                  )
                ).getTime() -
                new Date(
                  dayjs(item["utc_att_date"]).format("YYYY-MM-DD")
                ).getTime();

              item["official_punch_in_utc_datetime"] =
                dayjs(
                  Number(item["official_punch_in_utc_datetime_save"])
                ).hour() *
                  60 +
                dayjs(
                  Number(item["official_punch_in_utc_datetime_save"])
                ).minute();
              if (day < 0 && Math.abs(day) >= 86400000) {
                item["official_punch_in_utc_datetime"] = -(
                  item["official_punch_in_utc_datetime"] +
                  1440 * parseInt(Math.abs(day) / 86400000)
                );
              }
              if (day > 0 && Math.abs(day) >= 86400000) {
                item["official_punch_in_utc_datetime"] =
                  item["official_punch_in_utc_datetime"] +
                  1440 * parseInt(Math.abs(day) / 86400000);
              }
            } else {
              item["official_punch_in_utc_datetime"] = 0;
            }
            item["official_punch_in_utc_datetime_save_minutes"] =
              item["official_punch_in_utc_datetime"];
            // official

            if (item["official_punch_out_utc_datetime"]) {
              let day =
                new Date(
                  dayjs(item["official_punch_out_utc_datetime"]).format(
                    "YYYY-MM-DD"
                  )
                ).getTime() -
                new Date(
                  dayjs(item["utc_att_date"]).format("YYYY-MM-DD")
                ).getTime();

              item["official_punch_out_utc_datetime"] =
                dayjs(
                  Number(item["official_punch_out_utc_datetime_save"])
                ).hour() *
                  60 +
                dayjs(
                  Number(item["official_punch_out_utc_datetime_save"])
                ).minute();
              if (day < 0 && Math.abs(day) >= 86400000) {
                item["official_punch_out_utc_datetime"] = -(
                  item["official_punch_out_utc_datetime"] +
                  1440 * parseInt(Math.abs(day) / 86400000)
                );
              }
              if (day > 0 && Math.abs(day) >= 86400000) {
                item["official_punch_out_utc_datetime"] =
                  item["official_punch_out_utc_datetime"] +
                  1440 * parseInt(Math.abs(day) / 86400000);
              }
            } else {
              item["official_punch_out_utc_datetime"] = 0;
            }
            item["official_punch_out_utc_datetime_save_minutes"] =
              item["official_punch_out_utc_datetime"];
            // modify
            if (item["modified_punch_in_utc_datetime"]) {
              let day =
                new Date(
                  dayjs(item["modified_punch_in_utc_datetime"]).format(
                    "YYYY-MM-DD"
                  )
                ).getTime() -
                new Date(
                  dayjs(item["utc_att_date"]).format("YYYY-MM-DD")
                ).getTime();

              item["modified_punch_in_utc_datetime"] =
                dayjs(
                  Number(item["modified_punch_in_utc_datetime_save"])
                ).hour() *
                  60 +
                dayjs(
                  Number(item["modified_punch_in_utc_datetime_save"])
                ).minute();
              if (day < 0 && Math.abs(day) >= 86400000) {
                item["modified_punch_in_utc_datetime"] = -(
                  item["modified_punch_in_utc_datetime"] +
                  1440 * parseInt(Math.abs(day) / 86400000)
                );
              }
              if (day > 0 && Math.abs(day) >= 86400000) {
                item["modified_punch_in_utc_datetime"] =
                  item["modified_punch_in_utc_datetime"] +
                  1440 * parseInt(Math.abs(day) / 86400000);
              }
            } else {
              item["modified_punch_in_utc_datetime"] = 0;
            }
            // modify
            if (item["modified_punch_out_utc_datetime"]) {
              let day =
                new Date(
                  dayjs(item["modified_punch_out_utc_datetime"]).format(
                    "YYYY-MM-DD"
                  )
                ).getTime() -
                new Date(
                  dayjs(item["utc_att_date"]).format("YYYY-MM-DD")
                ).getTime();

              item["modified_punch_out_utc_datetime"] =
                dayjs(
                  Number(item["modified_punch_out_utc_datetime_save"])
                ).hour() *
                  60 +
                dayjs(
                  Number(item["modified_punch_out_utc_datetime_save"])
                ).minute();
              if (day < 0 && Math.abs(day) >= 86400000) {
                item["modified_punch_out_utc_datetime"] = -(
                  item["modified_punch_out_utc_datetime"] +
                  1440 * parseInt(Math.abs(day) / 86400000)
                );
              }
              if (day > 0 && Math.abs(day) >= 86400000) {
                item["modified_punch_out_utc_datetime"] =
                  item["modified_punch_out_utc_datetime"] +
                  1440 * parseInt(Math.abs(day) / 86400000);
              }
            } else {
              item["modified_punch_out_utc_datetime"] = 0;
            }
          });
        }

        that.curStaff = res.data["staff_uuid"];
        that.Data = res.data;
      });
    },
    onChange: function (val) {
      this.$emit("onChange", val);
    },
    toChangeRecord: function (val) {
      const that = this;
      that.iSEdited = true;
      // this.$confirmWarn(this.$t('message_essweb_form_textField_notIncorrect_title'),this.$t('label_essweb_RosterFormRecord_form_slide_modifyAttenndanceRecordWarningLabel')).then((res) => {
      //   if (res) that.iSEdited=true;
      // });
    },
    getLeaveType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type",
        url: "/leave-type/get-list/",

        global: false,
      }).then((res) => {
        that.LeaveTypeData = res.data;
      });
    },
    closeDialog: function () {
      this.iSEdited = false;
      this.$emit("close");
    },
    toSave: function (sender) {
      const that = this;
      //  2020-11-24 改为不走审批//2021-04-06 判断是否走审批
      this.showSender = false;
      let arr = [];
      that.Data["ess_att_attendance_detail"].map((item) => {
        let modifi_outTime = "";
        let modifi_inTime = "";
        // let start_Date = item["official_punch_in_utc_datetime_save"];
        // if (!start_Date) {
        let start_Date = item["utc_att_date"];
        // }
        if (Number(item["is_punch_in_required"])) {
          if (item["modified_punch_in_utc_datetime"] >= 0) {
            if (item["modified_punch_in_utc_datetime"] >= 1440) {
              let day = parseInt(item["modified_punch_in_utc_datetime"] / 1440);
              let min = item["modified_punch_in_utc_datetime"] % 1440;
              modifi_inTime = new Date(
                dayjs(
                  dayjs(start_Date).add(day, "day").format("YYYY-MM-DD")
                ).add(min, "minute")
              ).getTime();
            } else {
              modifi_inTime = new Date(
                dayjs(start_Date).format("YYYY-MM-DD") +
                  " " +
                  that.$timeMachine(item["modified_punch_in_utc_datetime"])
              ).getTime();
            }
          } else {
            //减
            if (
              Math.abs(Number(item["modified_punch_in_utc_datetime"])) >= 1440
            ) {
              let day = parseInt(item["modified_punch_in_utc_datetime"] / 1440);
              let min = item["modified_punch_in_utc_datetime"] % 1440;
              modifi_inTime = new Date(
                dayjs(
                  dayjs(start_Date)
                    .subtract(Math.abs(day), "day")
                    .format("YYYY-MM-DD")
                ).add(Math.abs(min), "minute")
              ).getTime();
            } else {
              modifi_inTime = new Date(
                dayjs(dayjs(start_Date).format("YYYY-MM-DD")).add(
                  Math.abs(Number(item["modified_punch_in_utc_datetime"])),
                  "minute"
                )
              ).getTime();
            }
          }
        } else {
          modifi_inTime = start_Date;
        }
        if (Number(item["is_punch_out_required"])) {
          if (item["modified_punch_out_utc_datetime"] >= 0) {
            if (item["modified_punch_out_utc_datetime"] >= 1440) {
              let day = parseInt(
                item["modified_punch_out_utc_datetime"] / 1440
              );
              let min = item["modified_punch_out_utc_datetime"] % 1440;
              modifi_outTime = new Date(
                dayjs(
                  dayjs(start_Date).add(day, "day").format("YYYY-MM-DD")
                ).add(min, "minute")
              ).getTime();
            } else {
              modifi_outTime = new Date(
                dayjs(start_Date).format("YYYY-MM-DD") +
                  " " +
                  that.$timeMachine(item["modified_punch_out_utc_datetime"])
              ).getTime();
            }
          } else {
            //减
            if (
              Math.abs(Number(item["modified_punch_out_utc_datetime"])) >= 1440
            ) {
              let day = parseInt(
                item["modified_punch_out_utc_datetime"] / 1440
              );
              let min = item["modified_punch_out_utc_datetime"] % 1440;
              modifi_outTime = new Date(
                dayjs(
                  dayjs(start_Date)
                    .subtract(Math.abs(day), "day")
                    .format("YYYY-MM-DD")
                ).add(Math.abs(min), "minute")
              ).getTime();
            } else {
              modifi_outTime = new Date(
                dayjs(dayjs(start_Date).format("YYYY-MM-DD")).add(
                  Math.abs(Number(item["modified_punch_out_utc_datetime"])),
                  "minute"
                )
              ).getTime();
            }
          }
        } else {
          modifi_outTime = item["modified_punch_out_utc_datetime_save"];
        }
        // 是否修改过
        if (!item["is_change_modified_punch_in_utc_datetime"]) {
          modifi_inTime = item["modified_punch_in_utc_datetime_save"];
        }
        if (!item["is_change_modified_punch_out_utc_datetime"]) {
          modifi_outTime = item["modified_punch_out_utc_datetime_save"];
        }
        arr.push({
          event_type_uuid: item["event_type_uuid"],
          event_type_code: item["event_type_code"],
          event_property_group_uuid: item["event_property_group_uuid"],
          event_uuid: item["event_uuid"],
          attendance_detail_uuid: item["uuid"],
          actual_punch_in_uuid: item["actual_punch_in_uuid"],
          actual_punch_out_uuid: item["actual_punch_out_uuid"],
          actual_punch_in_utc_datetime: item["actual_punch_in_utc_datetime"],
          actual_punch_in_time_zone: item["actual_punch_in_time_zone"],
          actual_punch_out_utc_datetime: item["actual_punch_out_utc_datetime"],
          actual_punch_out_time_zone: item["actual_punch_out_time_zone"],
          modified_punch_in_utc_datetime: modifi_inTime,
          modified_punch_in_time_zone: item["official_punch_in_time_zone"],
          modified_punch_out_utc_datetime: modifi_outTime,
          modified_punch_out_time_zone: item["official_punch_out_time_zone"],
        });
      });
      let data = {
        modified_working_minutes: that.Data.modified_working_minutes,
        modified_meal_mintues: that.Data.modified_meal_mintues,
        modified_break_minutes: that.Data.modified_break_minutes,
        modified_ot_minutes: that.Data.modified_ot_minutes,
        modified_late_minutes: that.Data.modified_late_minutes,
        modified_early_leave_minutes: that.Data.modified_early_leave_minutes,
        modified_leave_minutes: that.Data.modified_leave_minutes,
        modified_absense_minutes: that.Data.modified_absense_minutes,
        modified_before_work_minutes: that.Data.modified_before_work_minutes,
        modified_after_work_minutes: that.Data.modified_after_work_minutes,
        applicant_staff_uuid: that.Data.staff_uuid,
        submit_staff_uuid: that.curAppInfo
          ? that.curAppInfo["user"]["user_id"]
          : "",
        attendance_master_uuid: that.Data.uuid,
        official_shift_uuid: that.Data.official_shift_uuid,
        ess_att_attendance_modification_application_detail: arr,
        // sender_uuid: sender.join(","),//2020-11-24 改为不走审批
      };
      if (sender) data["sender_uuid"] = sender.join(","); //2021-04-06 判断是否走审批
      this.$confirmWarn(
        this.$t("message_essweb_form_textField_notIncorrect_title"),
        this.$t(
          "label_essweb_RosterFormRecord_form_slide_modifyAttenndanceRecordWarningLabel"
        )
      ).then((res) => {
        if (res)
          that
            .$Request({
              method: "POST",
              table: "ess_att_attendance_modification_application",
              url: "/attendance-modification-application/submit-application/",
              data: data,
              global: false,
              type: "client",
            })
            .then((res) => {
              that.closeDialog();
              that.$emit("onSubmit");
              that.$showMessage({
                text: that.$t(
                  "message_essweb_RosterFormRecord_form_slide_modifyAttenndanceRecordSuccessLabel"
                ),
                type: "success",
              });
            });
      });
    },

    toSubmit: function () {
      const that = this;
      this.is_skip_approval = 1;
      // 2020-11-24 改为不走审批
      //2021-04-06 判断是否本人再走审批
      //内部记录不走审批
      if (
        Number(that.curAppInfo["user"]["user_id"]) ===
          Number(that.Data.staff_uuid) &&
        Number(this.is_skip_approval) === 0
      ) {
        this.showSender = true;
      } else {
        this.toSave();
      }
    },
    getDays: function (start, end) {
      start = new Date(start);
      end = new Date(end);
      if (!start || !end) return "";
      if (isNaN(start) || isNaN(end)) return "";
      let day = parseInt((Number(start) - Number(end)) / (24 * 60 * 60 * 1000));
      return day > 0 ? "(+" + day + ")" : "";
    },
    getStartEnd: function (obj) {
      let text = "";
      if (obj["shift_adhoc"] != null) {
        let min = 0;
        let max = 0;
        if (obj["shift_adhoc"]["event_list"].length > 0) {
          min = Number(obj["shift_adhoc"]["event_list"][0]["start_utc_time"]);
          max = Number(obj["shift_adhoc"]["event_list"][0]["end_utc_time"]);
        }
        obj["shift_adhoc"]["event_list"].map((item) => {
          if (Number(item.start_utc_time) < min) {
            min = Number(item.start_utc_time);
          }
          if (Number(item.end_utc_time) < max) {
            max = Number(item.end_utc_time);
          }
        });
        text = this.$timeMachine(min) + " - " + this.$timeMachine(max);
      } else {
        text =
          this.$timeMachine(obj.start_utc_time) +
          " - " +
          this.$timeMachine(obj.end_utc_time);
      }
      return text;
    },
    getShiftList: function (staff) {
      const that = this;
      this.curStaff = staff;
      this.$Request({
        method: "POST",
        table: "ess_att_roster",
        url: "/roster-record/get-shifts/",
        data: {
          staff_uuid: staff,
          roster_form_record_uuid: this.curUuid,
        },
        global: false,
      }).then((res) => {
        res.data.every((ele) => {
          ele["shift_adhoc"] = null;
        });
        that.shiftListData = res.data;
        that.isRefresh = Math.random() * 10000000;
      });
    },
  },
};
</script>

<style scoped>
.special-action {
  position: absolute;
  width: 20px;
  height: 20px;
  /* border-top-left-radius: 40px; */
  background: transparent;
  bottom: 0;
  box-sizing: border-box;
  right: 0;
  border-bottom-right-radius: 5px;
  border: 10px solid;
  border-left-color: transparent;
  border-top-color: transparent;
  border-right: 10px solid;
  border-bottom: 10px solid;
}
.special-action > .material-icons-round {
  color: white;
  font-size: 16px;
  position: absolute;
  z-index: 3;
  margin-top: -5px;
  margin-left: -5px;
}
.active-class {
  border-width: 2px !important;
  box-sizing: border-box;
  border-style: solid !important;
  border-color: var(--main-color) !important;
}
.col-md-7 {
  -webkit-box-flex: 0 !important;
  -ms-flex: 0 0 58.3333333333% !important;
  flex: 0 0 58.3333333333% !important;
  max-width: 58.3333333333% !important;
}
</style>
